module.exports = "/_next/static/images/96c26fe22e48803f71086f753aefa9d5-image-right-lg.jpg.webp";